import {IsConfirmedConfiguration, IsConfirmedForm} from '../../../fields/isConfirmed/types'
import {CreateFormInput} from '../types'

export const buildIsConfirmedForm = ({
  inputProps,
  configuration: {isConfirmed}
}: CreateFormInput<IsConfirmedConfiguration>): IsConfirmedForm => {
  return {
    isConfirmedOrder: isConfirmed.enabled && !inputProps.confirmationPinRequired
  }
}
